import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText, Tooltip
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ImageGallery from '../../../../../propinfo/gallery/index';
import { Colxx } from '../../../../../../../../components/common/CustomBootstrap';
import timeZoneOptions from '../../../../../../../../data/timeZone';
import currencies from '../../../../../../../../data/currencies';
import ContactsForm from './ContactsForm';
import { AxiosAPI } from '../../../../../../../../helpers/AxiosAPI';
import { gAPI_Internal_Property_By_Id, gAPI_Group_By_Id, gAPI_Subscribed_Property_Products_List_By_Id, gAPI_Applicable_Products_List } from '../../../../../../../../constants/APIs';
import Select from 'react-select';
import { GetCurrencyConversion } from '../../../../../../../../data/CurrencyConversion';
import country from '../../../../../../../../data/country';
import { reactSelectOptionDiffrentPro } from '../../../../../../../../helpers/Utils';
import timeZoneList from '../../../../../../../../data/timeZoneList';
import currencyList from '../../../../../../../../data/currencyList';
import Rating from '../../../../../../../../components/common/Rating';
import languages from '../../../../../../../../data/languages';
import moment from 'moment';
import GptTemplate from './GptTemplates';
import IntlMessages from '../../../../../../../../helpers/IntlMessages';
export function PropertyForm({
  visible,
  toggle,
  formLabel,
  submit,
  updatepropertyData,
  id, check,
  groupId,
  groupCurrency,
  provider,
  service
}) {
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'Please Select',
  });
  const [isGptTemplate, setIsGptTemplate] = useState(false);
  const [propertyLanguage, setPropertyLanguage] = useState([]);
  const [monthlyBillingAmountNZD, setMonthlyBillingAmountNZD] = useState(0);
  const [selectZones, setSelectZones] = useState();
  const [startDate, setStartDate] = useState(null);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [showHotelId, setShowHotelId] = useState(false);
  // console.log('provider', provider, showHotelId);
  const [dataList, setDataList] = useState([]);
  let [propertyData, setpropertyData] = useState(
    updatepropertyData || {
      groupId: groupId,
      type: 'hotel',
      name: '',
      currency: 'NZD',
      inventoryProvider: 'External',
      ratesProvider: 'External',
      bookingProvider: 'External',
      timeZone: 'None',
      ariUrl: '',
      bookingUrl: '',
      creator: 'Manually',
      isTemplate: false,
      isWizard: false,
      displayOrder: 1,
      country: 'NZ',
      status: 'Active',
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      images: 'https://via.placeholder.com/150/',
      bmbAccountManager: '',
      bmbVoucherProcessingFee: 0,
      customerSuccessManager: '',
      isBmb: false,
      isAiva: false,
      isSpaceBooking: false,
      isVirtualFrontDesk: false,
      isRateBooking: false,
      isGuestService: false,
      activationDate: null,
      redeemAddress: '',
      averageDailyRate: 0,
      averageDailyRateUSD: 0,
      averageHourlyWageRate: 0,
      averageHourlyWageRateUSD: 0,
      monthlyBillingAmount: 0,
      monthlyBillingAmountNZD: 0,
      providerPropertyId: '',
      languages: ["en"],
      notes: "",
      senderName: provider && provider === 'concierge.synxis.com' ? 'Aven Hospitality Concierge' : 'Myma.ai',
      domains: [{ type: '' }],

    }
  );
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Internal_Property_By_Id}/${id}?group_id=${groupId}`,
      })
        .then(async (res) => {
          // console.log(154, res.data);
          setStartDate(moment(res.data.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? null
            : moment(res.data.activationDate).toDate());
          if (!res.data.domains || res.data.domains.length === 0) {
            res.data.domains = [{ type: 'AccommodationProviders' }];
          }

          if (res.data.languages !== null) {
            const filtered = languages.filter((el) => {
              return res.data.languages.indexOf(el.code) !== -1;
            });
            const languageList = languages.map((elem) => {
              elem.checked = false;
              filtered.forEach((lang) => {
                if (lang.code === elem.code) {
                  elem.checked = true;
                }
              });
              return elem;
            });

            setPropertyLanguage(languageList);

          }
          setpropertyData({
            ...res.data,
            isWizard: res.data.isWizard ?? false,
          });
          // let currency = currencyList.filter(item => item.countryCode === res.data.country);
          let timeZones = timeZoneList.filter(
            (item) => item.IsoAlpha2 === res.data.country
          );
          const countryGroup = country.filter(
            (item) => item.code === res.data.country
          );
          let countrySelected = {
            value: countryGroup[0].code,
            label: countryGroup[0].name,
          };
          setSelectedCountry(countrySelected);
          var rate = await GetCurrencyConversion(groupId);
          if (rate === 0) {
            setMonthlyBillingAmountNZD(res.data.monthlyBillingAmount);
          } else {
            var calculateBilling = res.data.monthlyBillingAmount * rate;
            setMonthlyBillingAmountNZD(calculateBilling);
          }
          // setpropertyData({
          //     ...propertyData,
          //     country: value.value,
          //     currency: currency[0].currencyCode
          // });

          setSelectZones(
            timeZones[0]?.TimeZones.map((zone) => {
              return <option value={zone}>{zone}</option>;
            })
          );
        })
        .catch((err) => console.log('err', err));
    }
    else {
      setPropertyLanguage(languages);
    }
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Subscribed_Property_Products_List_By_Id}/${id}`,
      })
        .then((res) => {
          const cleanedData = res.data.map(item => ({
            ...item,
            liveDate:
              moment(item.liveDate).format("MMM DD, YYYY") === "Jan 01, 0001"
                ? null
                : item.liveDate
                  ? moment.utc(item.liveDate).toDate()
                  : null,
          }));
          setDataList(cleanedData);
        })
        .catch((err) => console.log('err', err));
    }
    else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Applicable_Products_List}`,
      })
        .then((res) => {
          setDataList(res.data);
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);
  useEffect(() => {
    if (groupId) {
      if (service === '2' || service === '5') {
        setShowHotelId(true);
      } else {
        setShowHotelId(false);
      }
    }
  }, [groupId]);


  //  Auto-set domain if showHotelId = true
  useEffect(() => {
    if (showHotelId) {
      setpropertyData((prev) => ({
        ...prev,
        domains: [{ type: 'AccommodationProviders' }],
      }));
    }
  }, [showHotelId]);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
  };
  const handleRateChange = (e) => {
    setpropertyData({
      ...propertyData,
      starRating: e.rating,
    });
  };
  const handleCheckedChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.currentTarget.checked,
    });
  };
  // const handleCheckedlanguageChange = (e) => {
  //   const values = propertyLanguage.map((elem) => {
  //     if (elem.code === e.target.value) {
  //       elem.checked = !elem.checked;
  //     }
  //     return {
  //       ...elem,
  //     };
  //   });
  //   setPropertyLanguage(values);
  //   const langArr = propertyLanguage.filter((elem) => elem.checked === true).map((elem) => elem.code);
  //   setpropertyData({
  //     ...propertyData,
  //     languages: langArr,
  //   });
  // };
  const handleLanguageSelectChange = (selectedOptions) => {
    const selectedLangCodes = selectedOptions.map((option) => option.value);

    // Update checked state for visual consistency (optional, if still used elsewhere)
    const updatedLanguages = propertyLanguage.map((lang) => ({
      ...lang,
      checked: selectedLangCodes.includes(lang.code),
    }));

    setPropertyLanguage(updatedLanguages);

    setpropertyData({
      ...propertyData,
      languages: selectedLangCodes,
    });
  };


  const languageOptions = languages.map((lang) => ({
    value: lang.code,
    label: `${lang.name} (${lang.code})`,
  }));

  const selectedLanguages = propertyLanguage
    .filter((lang) => lang.checked)
    .map((lang) => ({
      value: lang.code,
      label: `${lang.name} (${lang.code})`,
    }));

  const togglegallery = () => {
    // setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const clickHandleCheckedChange = (e, index) => {
    const updatedList = [...dataList];
    updatedList[index].available = e.target.checked;
    if (!e.target.checked) updatedList[index].liveDate = null;
    setDataList(updatedList);
  };

  const handleLiveDateChange = (date, index) => {
    const updatedList = [...dataList];
    updatedList[index].liveDate = date
      ? moment(date).local().format("YYYY-MM-DD")
      : null;
    setDataList(updatedList);
  };
  const selectedImage = (image) => {

    setpropertyData({
      ...propertyData,
      images: image.src,
    });
  };

  // console.log(157, startDate, propertyData);
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleChangeSelect = (value, { name }) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    setpropertyData({
      ...propertyData,
      country: value?.value,
      currency: currency[0]?.currencyCode,
      timeZone: timeZones[0]?.TimeZones[0],
    });
    setSelectedCountry(value);
    setSelectZones(
      timeZones[0].TimeZones.map((zone) => {
        return <option value={zone}>{zone}</option>;
      })
    );
  };

  const handleSubmit = () => {
    const finalPropertyData = {
      ...propertyData,
      activationDate: startDate === null
        ? "01/01/0001"
        : moment(startDate).format('YYYY-MM-DD'),
    };
    const applicableProducts = {
      propertyId: id,
      createdBy: propertyData.creator,
      groupId: groupId,
      products: dataList.map((item) => ({
        productId: item.productId,
        productName: item.productName,
        available: item.available ?? false,
        liveDate: item.liveDate
          ? new Date(item.liveDate).toISOString()
          : null,
      })),
    };
    submit(finalPropertyData, applicableProducts);

  };

  const selectTimeZoneOptions = timeZoneOptions
    .sort(dynamicSort('label'))
    .map((item) => {
      return <option value={item.value}>{item.label}</option>;
    });

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const handleChangeDate = (date) => {
    setpropertyData({ ...propertyData, activationDate: moment(date) });
  };

  const filteredProducts = showHotelId ? dataList?.slice(0, 4) : dataList;
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(propertyData, null, 2)}</pre> */}
              <h4>Property Information</h4>
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>Property Name</Label>
                  <Input className='input_sty'
                    type="text"
                    value={propertyData.name}
                    onChange={handleChange}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Property Type</Label>
                  <Input className='input_sty'
                    type="select"
                    value={propertyData.type}
                    name="type"
                    onChange={handleChange}
                  >
                    <option value="ActivityProvider">Activity Provider</option>
                    <option value="CampGround">CampGround</option>
                    <option value="HolidayHome">Holiday Home</option>
                    <option value="Hostel">Hostel</option>
                    <option value="Hotel">Hotel</option>
                    <option value="Lodge">Lodge</option>
                    <option value="Motel">Motel</option>
                    <option value="Bach">Other Business Operator</option>
                    <option value="Pub">Pub</option>
                    <option value="Resort">Resort</option>
                  </Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Country</Label>
                  <Select
                    isMulti={false}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="code"
                    placeholder="Select Country"
                    onChange={handleChangeSelect}
                    value={selectedCountry}
                    options={
                      country
                        ? reactSelectOptionDiffrentPro(
                          country,
                          true,
                          'code',
                          'name',
                          ''
                        )
                        : []
                    }
                  />
                </Colxx>
                {/* <Colxx sm={3} className="mb-3">
                                    <Label>Currency</Label>
                                    <Input className='input_sty' 
                                        required
                                        name="currency"
                                        type="select"
                                        onChange={handleChange}
                                        value={propertyData.currency}
                                    >
                                        {selectCurrencies}
                                    </Input>
                                </Colxx> */}
                {selectZones !== undefined && selectZones.length > 0 && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Time Zone</Label>
                    <Input className='input_sty'
                      type="select"
                      value={propertyData.timeZone}
                      name="timeZone"
                      onChange={handleChange}
                    >
                      {selectZones}
                    </Input>
                  </Colxx>
                )}

                <div style={{ display: 'none' }}>
                  <Colxx sm={4} className="mb-3">
                    <Label>Inventory Provider</Label>
                    <Input className='input_sty'
                      type="select"
                      value={propertyData.inventoryProvider}
                      name="inventoryProvider"
                      onChange={handleChange}
                    >
                      <option value="None">None</option>
                      <option value="Rms">RMS</option>
                      <option value="Clarity">Clarity</option>
                      <option value="Bmb">Bmb</option>
                      <option value="External">External</option>
                      <option value="GuestTraction">Guest Traction</option>
                      <option value="TravelClick">Travel Click</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <FormGroup>
                      <Label> BMB Voucher Processing Fee
                      </Label>
                      <InputGroup>

                        <Input className='input_sty'
                          type="number"
                          name="bmbVoucherProcessingFee"
                          id="bmbVoucherProcessingFee"
                          onChange={handleChange}
                          value={parseFloat(propertyData.bmbVoucherProcessingFee)}
                        />
                        <InputGroupAddon addonType='postpend'>
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                      <Tooltip
                        isOpen={tooltipOpen}
                        placement="left"
                        target="bmbVoucherProcessingFee"
                        toggle={() => { setTooltipOpen(!tooltipOpen) }}>
                        Myma.ai processing fee includes the credit card transaction fee that we directly pay out to the Credit Card processor.
                      </Tooltip>
                      {/* <Tooltip></Tooltip > */}
                    </FormGroup>
                  </Colxx>

                  <Colxx sm={4} className="mb-3">
                    <Label>Rates Provider</Label>
                    <Input className='input_sty'
                      type="select"
                      value={propertyData.ratesProvider}
                      name="ratesProvider"
                      onChange={handleChange}
                    >
                      <option value="None">None</option>
                      <option value="Rms">RMS</option>
                      <option value="Clarity">Clarity</option>
                      <option value="Bmb">Bmb</option>
                      <option value="External">External</option>
                      <option value="GuestTraction">Guest Traction</option>
                      <option value="TravelClick">Travel Click</option>
                    </Input>
                  </Colxx>
                  <Colxx sm={4} className="mb-3" >
                    <Label>Booking Provider</Label>
                    <Input className='input_sty'
                      type="select"
                      value={propertyData.bookingProvider}
                      name="bookingProvider"
                      onChange={handleChange}
                    >
                      <option value="None">None</option>
                      <option value="Rms">RMS</option>
                      <option value="Clarity">Clarity</option>
                      <option value="Bmb">Bmb</option>
                      <option value="External">External</option>
                      <option value="GuestTraction">Guest Traction</option>
                      <option value="TravelClick">Travel Click</option>
                    </Input>
                  </Colxx>
                </div>



                <div style={{ display: 'none' }}>
                  <Colxx sm={4} className="mb-3">
                    <Label>Monthly Billing Amount ({groupCurrency})</Label>
                    <Input className='input_sty'
                      type="number"
                      min={0}
                      value={propertyData.monthlyBillingAmount}
                      name="monthlyBillingAmount"
                      onChange={handleChange}
                    ></Input>
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Monthly Billing Amount (NZD)</Label>
                    <Input className='input_sty'
                      type="number"
                      min={0}
                      value={monthlyBillingAmountNZD}
                      name="monthlyBillingAmountNZD"
                      disabled
                    ></Input>
                  </Colxx>


                  <Colxx sm={12} className="mb-3">
                    <Label>ARI URL</Label>
                    <Input className='input_sty'
                      type="text"
                      value={propertyData.ariUrl}
                      onChange={handleChange}
                      name="ariUrl"
                    />
                  </Colxx>
                  <Colxx sm={12} className="mb-3">
                    <Label>Booking Page URL</Label>
                    <Input className='input_sty'
                      type="text"
                      value={propertyData.bookingUrl}
                      onChange={handleChange}
                      name="bookingUrl"
                    />
                  </Colxx>
                </div>
                <Colxx sm={2} className="mb-3">
                  <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                  <Input className='input_sty'
                    type="number"
                    name="displayOrder"
                    min={1}
                    value={propertyData.displayOrder}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Status</Label>
                  <Input className='input_sty'
                    type="select"
                    value={propertyData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Live">Live</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Archived">Archived</option>
                  </Input>
                </Colxx>
                <div style={{ display: 'none' }}>
                  <Colxx sm={3} className="mb-3">
                    <FormGroup>
                      <Label>
                        <Input className='input_sty'
                          type="checkbox"
                          name="isTemplate"
                          id="isTemplate"
                          onChange={handleCheckedChange}
                          checked={propertyData.isTemplate}
                        />
                        Is Template
                      </Label>
                    </FormGroup>
                  </Colxx>
                  <Colxx sm={4} className="mb-3">
                    <Label>Rooms</Label>
                    <Input className='input_sty'
                      type="number"
                      value={propertyData.rooms}
                      onChange={handleChange}
                      name="rooms"
                    />
                  </Colxx>
                </div>
                <Colxx sm={6} className="mb-3">
                  <Label>Website Link</Label>
                  <Input className='input_sty'
                    type="text"
                    value={propertyData.websiteLink}
                    onChange={handleChange}
                    name="websiteLink"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Notes</Label>
                  <Input className='input_sty'
                    type="textarea"
                    value={propertyData.notes}
                    name="notes"
                    onChange={handleChange}
                  >
                  </Input>
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Star Rating</Label>
                  <Rating
                    total={7}
                    rating={propertyData.starRating}
                    onRate={handleRateChange}
                  />
                </Colxx>

                <div style={{ display: 'none' }}>
                  <Colxx sm={6} className="mb-3">
                    <Label>BMB Account Manager</Label>
                    <Input className='input_sty'
                      type="text"
                      value={propertyData.bmbAccountManager}
                      onChange={handleChange}
                      name="bmbAccountManager"
                    />
                  </Colxx>

                  <Colxx sm={6} className="mb-3">
                    <Label>Customer Success Manager</Label>
                    <Input className='input_sty'
                      type="text"
                      value={propertyData.customerSuccessManager}
                      onChange={handleChange}
                      name="customerSuccessManager"
                    />
                  </Colxx>
                </div>
                <Fragment><Colxx sm={12}>
                  <h4>Logo</h4>
                </Colxx>
                  <Colxx sm={12}>

                    <Row>
                      <Colxx sm={2} className="md-3">
                        <img
                          style={{
                            width: '100%',
                            height: '90%',
                          }}
                          alt="room image"
                          src={
                            propertyData.images || 'https://via.placeholder.com/150/'
                          }
                        />
                      </Colxx>
                      <Colxx sm={1} className="mb-3">
                        <Label>Browse</Label>
                        <div
                          className="iconsminds-photo"
                          onClick={(event) => togglegallery()}
                          style={{
                            cursor: 'pointer',
                            fontSize: '28px',
                            color: '#73236b',
                          }}
                        ></div>
                      </Colxx>
                    </Row>
                  </Colxx>

                </Fragment>
              </Row>
            </Colxx>

            <Colxx xxs="12" className=" mt-3">
              <h4>System Configuration</h4>

              <Row>
                <Colxx sm={4} className="mb-3 mt-2">
                  <Label>Average Daily Room Rate ({propertyData.currency})</Label>
                  <Input className='input_sty'
                    type="number"
                    min={0}
                    value={propertyData.averageDailyRate}
                    name="averageDailyRate"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Average Daily Room Rate (USD)</Label>
                  <Input className='input_sty'
                    type="number"
                    min={0}
                    value={propertyData.averageDailyRateUSD}
                    name="averageDailyRateUSD"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Average Hourly Wage Rate ({propertyData.currency})</Label>
                  <Input className='input_sty'
                    type="number"
                    min={0}
                    value={propertyData.averageHourlyWageRate}
                    name="averageHourlyWageRate"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <Colxx sm={4} className="mb-3">
                  <Label>Average Hourly Wage Rate (USD)</Label>
                  <Input className='input_sty'
                    type="number"
                    min={0}
                    value={propertyData.averageHourlyWageRateUSD}
                    name="averageHourlyWageRateUSD"
                    onChange={handleChange}
                  ></Input>
                </Colxx>
                <div style={{ display: 'none' }}>
                  <Colxx sm={6} className="mb-3">
                    <Label>Redeem At Address</Label>
                    <Input className='input_sty'
                      type="textarea"
                      value={propertyData.redeemAddress}
                      name="redeemAddress"
                      onChange={handleChange}
                    >
                    </Input>
                  </Colxx>
                </div>

                <Colxx sm={4} className="mb-3">
                  <Label>Email Sender Name</Label>
                  <Input className='input_sty'
                    type="text"
                    value={propertyData.senderName}
                    name="senderName"
                    onChange={handleChange}
                  >
                  </Input>
                </Colxx>
                {showHotelId && (
                  <Colxx sm={4} className="mb-3">
                    <Label>SynXis Hotel ID</Label>
                    <Input className='input_sty'
                      type="text"
                      value={propertyData.providerPropertyId}
                      onChange={handleChange}
                      name="providerPropertyId"
                    />
                  </Colxx>
                )}
                <Colxx sm={6} className="mb-2">
                  <Label>Live Date</Label>
                  {/* <DatePicker
                selected={moment(propertyData.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? moment() : moment(propertyData.activationDate)}
                onChange={handleChangeDate}
                placeholderText="Activation Date"
                dateFormat="DD/MM/YYYY"
              /> */}
                  <DatePicker
                    selected={startDate}
                    onChange={date => setStartDate(date)}
                    placeholderText="Live Date"
                    dateFormat="dd/MM/yyyy"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3 mt-3">
                  <FormGroup style={{ left: '22px', top: '20px' }}>
                    <Input className='input_sty'
                      type="checkbox"
                      name="isWizard"
                      id="isWizard"
                      onChange={handleCheckedChange}
                      checked={propertyData.isWizard}
                    />
                    <Label>
                      Display Setup Wizard
                    </Label>
                  </FormGroup>
                </Colxx>
                <Colxx sm={12} className="mb-3">
                  <h4 style={{ marginTop: "25px" }} className="header">
                    Applicable Products
                  </h4>

                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "14.5px",
                        backgroundColor: "#f3f5fb",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              backgroundColor: "#ffffff",
                              color: "#212121",
                              fontWeight: 600,
                              padding: "12px 15px",
                              textAlign: "left",
                              border: "1px solid #d6d9e4",
                            }}
                          >
                            Product
                          </th>
                          <th
                            style={{
                              backgroundColor: "#ffffff",
                              color: "#212121",
                              fontWeight: 600,
                              padding: "12px 15px",
                              textAlign: "center",
                              border: "1px solid #d6d9e4",
                            }}
                          >
                            Available
                          </th>
                          <th
                            style={{
                              backgroundColor: "#ffffff",
                              color: "#212121",
                              fontWeight: 600,
                              padding: "12px 15px",
                              textAlign: "center",
                              border: "1px solid #d6d9e4",
                            }}
                          >
                            Live Date
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {filteredProducts?.map((item, index) => {
                          return (
                            <tr
                              key={item.productId}
                              style={{
                                backgroundColor: "#ffffff",
                              }}
                            >
                              <td
                                style={{
                                  padding: "12px 15px",
                                  border: "1px solid #d6d9e4",
                                  verticalAlign: "middle",
                                }}
                              >
                                {item.productName}
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  border: "1px solid #d6d9e4",
                                  height: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "90%",
                                  }}
                                >
                                  <Input className='input_sty'
                                    type="checkbox"
                                    name={item.productName}
                                    id={item.productName}
                                    onChange={(e) => clickHandleCheckedChange(e, index)}
                                    checked={item.available}
                                    style={{
                                      transform: "scale(1.2)",
                                      cursor: "pointer",
                                      margin: 0,
                                    }}
                                  />
                                </div>
                              </td>
                              <td
                                style={{
                                  border: "1px solid #d6d9e4",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  height: "40px",
                                  padding: 0,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "80%",
                                    width: "100%",
                                  }}
                                >
                                  {item.available && (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "90%",
                                      }}
                                    >
                                      <DatePicker
                                        selected={item.liveDate ? new Date(item.liveDate) : null}
                                        onChange={(date) => handleLiveDateChange(date, index)}
                                        placeholderText="Live Date"
                                        dateFormat="dd/MM/yyyy"
                                        wrapperClassName="d-inline-block"
                                        customInput={
                                          <Input className='input_sty'
                                            style={{
                                              textAlign: "center",
                                              transition: "all 0.2s ease-in-out",
                                              display: "block",
                                              boxSizing: "border-box",
                                            }}
                                            onFocus={(e) => {
                                              e.target.style.borderColor = "#f28b82";
                                              e.target.style.boxShadow = "0 0 3px rgba(242,139,130,0.6)";
                                            }}
                                            onBlur={(e) => {
                                              e.target.style.borderColor = "#ccc";
                                              e.target.style.boxShadow = "none";
                                            }}
                                          />
                                        }
                                      />
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Colxx>

                <Colxx sm={8} className="">

                  <Label>Knowledge Base Languages</Label>
                  <p style={{ fontSize: '12px', color: 'gray' }}>Select only the languages content needs to be maintained in.</p>
                  <FormGroup className="">
                    {/* <Label>
                        <Input className='input_sty' 
                          type="checkbox"
                          name={elem.code}
                          id={elem.code}
                          value={elem.code}
                          onChange={handleCheckedlanguageChange}
                          checked={elem.checked}
                        />
                        {elem.name} ({elem.code})
                      </Label> */}
                    <Select
                      isMulti
                      name="languages"
                      className="react-select mt-2"
                      classNamePrefix="react-select"
                      placeholder="Select Languages"
                      options={languageOptions}
                      value={selectedLanguages}
                      onChange={handleLanguageSelectChange}
                    />

                  </FormGroup>

                </Colxx>
                {!showHotelId && (
                  propertyData.domains && (
                    <Colxx sm={6} className="mb-3">
                      <Label>Domain Type</Label>
                      <Input className='input_sty'
                        type="select"
                        name="domainType"
                        value={propertyData.domains?.[0]?.type || ''}
                        // onChange={(e) => {
                        //   const updatedDomainType = e.target.value;
                        //   const updatedDomains = [{ ...propertyData.domains?.[0], type: updatedDomainType }];
                        //   setpropertyData({ ...propertyData, domains: updatedDomains });
                        // }}
                        onChange={(e) => {
                          const selectedType = e.target.value;
                          setpropertyData((prev) => ({
                            ...prev,
                            domains: [{ type: selectedType }],
                          }));
                        }}

                      >
                        <option value="" disabled>Please select domain type</option>
                        <option value="AccommodationProviders">
                          Accommodation Providers
                        </option>
                        <option value="Lawnmowers">Lawnmowers</option>
                        <option value="Electricians">Electricians</option>
                        <option value="Coaching">Coaching</option>
                        <option value="Retail">Retail</option>
                        <option value="Covid">Covid</option>
                        <option value="Smalltalk">Smalltalk</option>
                        <option value="RetirementHomes">Retirement Homes</option>
                        <option value="Salons">Salons</option>
                        <option value="SalonsSmallTalk">Salons SmallTalk</option>
                        <option value="HolidaysPark">Holidays Park</option>
                        <option value="QuarantineBot">Quarantine Bot</option>
                        <option value="HolidayHomes">Holiday Homes</option>
                        <option value="VirtualVetNurse">Virtual Vet Nurse</option>
                        <option value="Tourism">Tourism</option>
                        <option value="Doctors">Doctors</option>
                        <option value="Northable">Northable</option>
                        <option value="Golf">Golf</option>
                        <option value="BusinessOperator">Business Operator</option>
                        <option value="VoucherEngine">VoucherEngine</option>
                        <option value="Activities">Activities</option>
                        <option value="Restaurant">Restaurant</option>
                        <option value="UtilityProviders">Utility Providers</option>
                      </Input>
                    </Colxx>

                  )
                )}
              </Row>
            </Colxx>
          </Row>
          {ImageGalleryButton()}
          {id === undefined &&
            propertyData.contacts && (
              <ContactsForm images={propertyData.contacts} id={id} />
            )
          }

        </ModalBody >
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          {id !== undefined &&
            <Button color="dark" onClick={() => setIsGptTemplate(true)}>
              GPT Template
            </Button>
          }
        </ModalFooter>
      </Modal >
      {
        isGptTemplate &&
        <GptTemplate
          id={id}
          visible={isGptTemplate}
          toggle={() => setIsGptTemplate(false)}
          gptTemplate={propertyData.gptPromptTemplates}>
        </GptTemplate>
      }

    </Fragment >
  );
}
